import { PayloadAction } from '../../../store.model';
import { createFilteredQuotesLookup } from '../function/create-filtered-quotes-lookup.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    DeleteTranscriptQuotes,
    DeleteTranscriptQuotesResult,
} from './delete-transcript-quotes.action';

export function deleteTranscriptQuotesReducer(
    state: TranscriptDialogState,
    _: PayloadAction<ActionType, DeleteTranscriptQuotes>,
): TranscriptDialogState {
    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: true,
        },
    };
}

export function deleteTranscriptQuotesResultReducer(
    state: TranscriptDialogState,
    action: PayloadAction<ActionType, DeleteTranscriptQuotesResult>,
): TranscriptDialogState {
    const entries =
        state.transcript.entries?.filter(
            (e) =>
                !action.payload.transcriptQuoteIds.includes(
                    e.transcriptEntryId,
                ),
        ) ?? [];
    const filteredQuotes =
        state.filteredQuotes?.filter(
            (e) =>
                !action.payload.transcriptQuoteIds.includes(
                    e.transcriptEntryId,
                ),
        ) ?? [];

    const { lookup: nextLookup, all: nextAllQuotesAreSelected } =
        createFilteredQuotesLookup(filteredQuotes, []);

    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: false,
        },
        transcript: {
            ...state.transcript,
            entries,
        },
        filteredQuotes,
        selectedQuotes: [],
        filteredQuotesSelectedLookup: nextLookup,
        allQuotesAreSelected: nextAllQuotesAreSelected,
    };
}
